import { AudioManager } from '../../../core/AudioManager';
import { PositionalOptions } from '../../../core/AudioManager.types';
import { Character } from '../../Character';

export class PanicAudio {
    static readonly PRELOAD = [
        '../assets/sounds/man_panic.wav',
        '../assets/sounds/woman_panic.wav',
    ] as const;

    private static readonly OPTIONS: PositionalOptions = { volume: 1, loop: false, refDistance: 10 };

    constructor(
        private readonly audioManager: AudioManager,
        private readonly character: Character,
    ) {}

    public play(): void {
        const src = this.character.gender === 'woman'
            ? PanicAudio.PRELOAD[1]
            : PanicAudio.PRELOAD[0];
        this.audioManager.playPositional(src, this.character, PanicAudio.OPTIONS);
    }
}
